import {ReactNode} from "react";
import {css, SerializedStyles} from "@emotion/react";
import {mt, onDesktop, pb, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

export const MICRO_COPY_TEXT_VARIANT = "info_txt_1" as const;

const microCopyBulletBefore = css`
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background-color: #ebff00;
    margin-right: 0.75rem;
`;

export const microCopyListItem = (itemSpacing: SerializedStyles = microCopyListItemSpacingTight) => css`
    list-style: none;

    &::before {
        ${microCopyBulletBefore};
    }

    ${itemSpacing};
`;

export const microCopyListItemSpacingTight = css`
    & + & {
        ${mt(1)};
    }
`;

export const microCopyListItemSpacingRelaxed = css`
    & + & {
        ${mt(2)};
    }
`;

export const microCopyListItemSpacingNone = css``;

export const microCopyList = css`
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const microCopyListUnderCta = css`
    ${microCopyList};
    ${pt(0)};
    ${pb(4)};
    ${mt(4)};

    ${onDesktop(css`
        ${mt(5)};
    `)}
`;

export const microCopyAudienceList = css`
    ${microCopyList};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    column-gap: 2rem;
    row-gap: 0.75rem;

    ${onDesktop(css`
        flex-wrap: nowrap;
    `)}
`;

export const microCopyAudienceListItem = css`
    ${microCopyListItem(microCopyListItemSpacingNone)};
    white-space: nowrap;
`;

export const microCopyLine = css`
    margin: 0;

    &::before {
        ${microCopyBulletBefore};
    }
`;

type LandingMicroCopyLineProps = {
    children: ReactNode;
    align?: "left" | "center" | "right";
};

export const LandingMicroCopyLine = ({children, align = "center"}: LandingMicroCopyLineProps) => (
    <Text variant={MICRO_COPY_TEXT_VARIANT} as="p" align={align} css={microCopyLine}>
        {children}
    </Text>
);

type LandingMicroCopyListProps = {
    items: ReactNode[];
    listCss?: SerializedStyles;
    itemSpacing?: SerializedStyles;
};

export const LandingMicroCopyList = ({
    items,
    listCss = microCopyList,
    itemSpacing = microCopyListItemSpacingTight
}: LandingMicroCopyListProps) => (
    <ul css={listCss}>
        {items.map((item, index) => (
            <li key={index} css={microCopyListItem(itemSpacing)}>
                <Text variant={MICRO_COPY_TEXT_VARIANT} as="span">
                    {item}
                </Text>
            </li>
        ))}
    </ul>
);
